import React from 'react'
import Content from '../Content'
import { Wrapper } from './styles'

export const Layout = ({
  adjustPageContainerForMenu,
  children,
  className,
  style,
  constrainWidth,
  disableGutter,
  left,
  right
}) => {
  return (
    <Wrapper style={style} className={className}>
      <Content
        adjustPageContainerForMenu={adjustPageContainerForMenu}
        constrainWidth={constrainWidth}
        disableGutter={disableGutter}
        left={left}
        right={right}
      >
        {children}
      </Content>
    </Wrapper>
  )
}
export default Layout
